import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { AlertTriangle } from "lucide-react";
import { useTranslation, Trans } from "react-i18next";

interface DeleteRecordDialogProps {
  open: boolean;
  recordName: string;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
}

export const DeleteRecordDialog = ({
  open,
  recordName,
  onClose,
  onConfirm,
  isDeleting,
}: DeleteRecordDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-red-100">
              <AlertTriangle className="h-5 w-5 text-red-600" />
            </div>
            <DialogTitle>{t('records.delete_record_title')}</DialogTitle>
          </div>
          <DialogDescription className="pt-3">
            <Trans
              i18nKey="records.delete_record_confirmation"
              values={{ name: recordName }}
              components={{ 1: <strong /> }}
            />
            <br />
            {t('records.delete_record_warning')}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-row justify-end gap-2 sm:justify-end">
          <Button
            type="button"
            variant="outline"
            onClick={onClose}
            disabled={isDeleting}
          >
            {t('common.cancel')}
          </Button>
          <Button
            type="button"
            variant="destructive"
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? t('records.deleting') : t('records.delete')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

